import React, { useState } from 'react';

import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from '@mui/material';

import Button from 'components/Button';
import { useCollectiveFilter } from 'contexts/CollectiveFilterContext';
import GlobalModal from 'modals/GlobalModal/GlobalModal';
import { useCollectiveTeams } from 'pages/CollectiveProfileMembers/hooks/useCollectiveTeams';

interface Props {
  open: boolean;
  onClose: () => void;
}

const connectionTypes = [
  { value: 'FAVORITED', label: 'Favorito' },
  { value: 'CONTACT', label: 'Contato' },
  { value: 'CONNECTION', label: 'Conexão' },
  { value: 'INFLUENCER', label: 'Influenciador' },
  // { value: 'LIKE', label: 'Gostei' },
  // { value: 'DISLIKE', label: 'Não gostei' },
];

const CollectiveFilterModal: React.FC<Props> = ({ open, onClose }) => {
  const { filter, setFilter, clearFilter } = useCollectiveFilter();
  const { teams, isLoading: loadingTeams } = useCollectiveTeams();
  const [localFilter, setLocalFilter] = useState(filter);

  React.useEffect(() => {
    if (open) setLocalFilter(filter);
  }, [open, filter]);

  React.useEffect(() => {
    console.log('[CollectiveFilterModal] Filtros selecionados:', localFilter);
  }, [localFilter]);

  const handleApply = () => {
    setFilter(localFilter);
    onClose();
  };

  const handleClear = () => {
    clearFilter();
    setLocalFilter({
      teams: [],
      connectionTypes: [],
      applyGlobally: false,
    });
  };

  return (
    <GlobalModal
      open={open}
      title="FILTROS"
      onClose={onClose}
      onConfirm={handleApply}
      onCancel={onClose}
      confirmButtonText="Filtrar"
      cancelButtonText="Cancelar"
      width="32rem"
      height="auto"
    >
      <Stack spacing={2} mt={2}>
        <FormControl fullWidth>
          <InputLabel>Grupo temático</InputLabel>
          <Select
            multiple
            value={localFilter.teams}
            onChange={e =>
              setLocalFilter(prev => ({
                ...prev,
                teams: (e.target.value as (string | number)[]).map(String),
              }))
            }
            input={<OutlinedInput label="Grupo temático" />}
            renderValue={selected =>
              (selected as string[])
                .map(id => teams.find(t => String(t.id) === id)?.name)
                .filter(Boolean)
                .join(', ')
            }
            disabled={loadingTeams}
          >
            {teams.map(team => (
              <MenuItem key={team.id} value={String(team.id)}>
                <Checkbox checked={localFilter.teams.includes(String(team.id))} />
                <ListItemText primary={team.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Tipo de conexão</InputLabel>
          <Select
            multiple
            value={localFilter.connectionTypes}
            onChange={e =>
              setLocalFilter(prev => ({ ...prev, connectionTypes: e.target.value as string[] }))
            }
            input={<OutlinedInput label="Tipo de conexão" />}
            renderValue={selected =>
              (selected as string[])
                .map(val => connectionTypes.find(t => t.value === val)?.label)
                .filter(Boolean)
                .join(', ')
            }
          >
            {connectionTypes.map(type => (
              <MenuItem key={type.value} value={type.value}>
                <Checkbox checked={localFilter.connectionTypes.includes(type.value)} />
                <ListItemText primary={type.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider />
        <FormControlLabel
          control={
            <Checkbox
              checked={localFilter.applyGlobally}
              onChange={e => setLocalFilter(prev => ({ ...prev, applyGlobally: e.target.checked }))}
            />
          }
          label="Aplicar filtros em todas as telas"
        />
        <Button size="small" variant="minimal" color="primary" onClick={handleClear}>
          Limpar filtros
        </Button>
      </Stack>
    </GlobalModal>
  );
};

export default CollectiveFilterModal;
